import React from "react";
import Box from "@mui/material/Box";
import GameList from "../components/Events/GameList";
import PageContainer from "./PageContainer";
const SingleEvent = () => {
  return (
    <PageContainer>
      <GameList />
    </PageContainer>
  );
};

export default SingleEvent;
